module.exports = __webpack_public_path__ + "img/logo-1.b4ceac86.png";